import {Injectable} from "@angular/core";
import {BroadcasterService} from "../broadcaster.service";
import { HttpClient } from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ProcessBatchService {

    constructor(private broadcaster: BroadcasterService, private http: HttpClient, private router: Router, private route: ActivatedRoute) {}

    public processBatch(batchId, patients): Observable<any> {
        return new Observable<any>(observer => {
            this.http.post<any>(environment.apiUrl + 'de/splitBatch', {sid: localStorage.getItem('token'),
                batch_id: batchId, patients})
                .subscribe((res: any) => {
                    observer.next(res);
                }, err => {
                    observer.error(err);
                });
        });
    }
}
